import Link from 'next/link';
import { c } from '../../../utils/tailwind-merge';
import { Bar } from '../../atoms/Bar';
import { ReviewBarProps } from './ReviewBar.types';

export const ReviewBar = ({
  className,
  max,
  onFilterReviews,
  microcopy,
  reviews,
  value,
}: ReviewBarProps) => {
  return (
    <div className={c('flex items-center text-sm', className)}>
      <span className="font-normal tracking-[-0.028px] text-grey-900">
        {microcopy.rating}
      </span>
      <Bar
        className="mx-3"
        value={value}
        max={max}
        ariaLabel={microcopy.ariaLabel}
      />
      {reviews === 0 ? (
        <span className="text-grey-450">{reviews}</span>
      ) : (
        <Link
          className={'tracking-[-0.028px] text-blue no-underline'}
          onClick={() => onFilterReviews(reviews)}
          aria-label={microcopy.ratingAriaLabel}
          href={'#'}
          title={microcopy.ratingAriaLabel}
        >
          {reviews}
        </Link>
      )}
    </div>
  );
};
